export default function LtxLogo() {
  return <img src="/logos/ltx-logo.jpg" alt="LTX" width="16" height="16" className="block" />
}
